import { render, staticRenderFns } from "./reward-setting.vue?vue&type=template&id=17388a0e&"
import script from "./reward-setting.vue?vue&type=script&lang=js&"
export * from "./reward-setting.vue?vue&type=script&lang=js&"
import style0 from "./reward-setting.vue?vue&type=style&index=0&id=17388a0e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports